import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Hero from './Hero';

/* Spacing below matches previous Parallax banner rhythm */
const BannerWrapper = styled.div`
  margin-bottom: clamp(1.5rem, 3.5vw, 2.75rem);
`;

/**
 * Page top banner — same treatment as Day Tickets: compact `Hero`, centred copy,
 * symmetric overlay (see `Hero` with compact + centered).
 */
const ParallaxBanner = ({
  image,
  imageUrl,
  backgroundImage,
  imagePosition,
  welcomeText,
  mainTitle,
  title,
  subtitle,
  logo,
}) => {
  /* Events page (and others) used backgroundImage; standard is image / imageUrl */
  const displayImage = image || imageUrl || backgroundImage;
  const displayTitle = mainTitle || title;

  if (!displayImage || !displayTitle) {
    return null;
  }

  return (
    <BannerWrapper>
      <Hero
        backgroundImage={displayImage}
        backgroundPosition={imagePosition}
        compact
        centered
        welcomeText={welcomeText || undefined}
        mainTitle={displayTitle}
        logo={logo || undefined}
        subtitle={subtitle || undefined}
      />
    </BannerWrapper>
  );
};

ParallaxBanner.propTypes = {
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  imageUrl: PropTypes.string,
  backgroundImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  imagePosition: PropTypes.string,
  welcomeText: PropTypes.string,
  mainTitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  logo: PropTypes.string,
};

export default ParallaxBanner;
